import { Button } from "@/components/ui/button";
import { CopyToClipboard } from "@/features/shared/components/CopyToClipboard";
import { CalendlyExpert } from "../types/CalendlyExpert";

interface Props {
    expert: CalendlyExpert;
    onCloseClick: () => void;
}

const ContactExpertDialog: React.FC<Props> = ({ expert, onCloseClick }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="w-[90%] bg-white rounded-md absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center shadow-platform-new border border-solid border-border p-4 md:w-[362px]">
                <div className="w-full h-full flex flex-col justify-between space-y-3">
                    <div className="font-bold text-lg">Vuoi scrivere a <span className="text-primary">{expert.data.name} {expert.data.family_name}</span>?</div>
                    <div className="font-normal">
                        Qui di seguito hai a disposizione la email del tuo professionista (<span className="font-bold">{expert.email}</span>) se hai bisogno di una comunicazione urgente.
                    </div>
                    <CopyToClipboard textToCopy={expert.email || ""} className="flex items-center space-x-1 text-black">
                        <Button
                            size="form"
                            onClick={() => {
                                setTimeout(() => {
                                    onCloseClick();
                                }, 100);
                            }}
                        >
                            Copia email
                        </Button>
                    </CopyToClipboard>
                    <Button
                        size="sm"
                        variant={'white'}
                        className="normal-case text-sm"
                        onClick={onCloseClick}
                    >
                        Chiudi
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default ContactExpertDialog
